module.exports = __webpack_public_path__ + "img/FR14006.360d9c60.png";